<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em">And then… This is it.</p><br/>
<p style="text-indent:0em">This is especially dedicated to my late friend Deon Webb. There is not a single day that goes by without having you in my thoughts. I was inspired by your selfless, caring, and kind qualities.</p><br/>
<p style="text-indent:0em">Like many others, you have sought love and acceptance and had failed in overcoming such feats on your quest for happiness, of which you so sincerely deserved.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0b9f239c